import React from "react";
import { Text } from "@chakra-ui/react";
import "./home.css";
import Button from "../../components/buttonSvg";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="container">
      <p>DENEME</p>

      <div className="header">
        <div className="header__right">
          <a href="/">
            <Text fontWeight="black" color="#fff" fontSize={20}>
              Muhammed Deniz
            </Text>
          </a>
        </div>

        <div className="header__left">
          <Link to="/home">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Home
            </Text>
          </Link>

          <Link to="/privacypolicy/ChatGame">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Privacy Policy
            </Text>
          </Link>

          <Link to="/termsOfUse/ChatGame">
            <Text fontSize="m" mr={5} fontWeight="black" color="#fff">
              Terms Of Use
            </Text>
          </Link>
        </div>
      </div>

      <div className="content">
        <p className="title_p">About Me!</p>

        <p className="content_text">
          Hello, I'm Muhammed Deniz, I'm a computer engineer. I'm developing
          myself in the front-end and mobile field. If you want to learn more
          about me or reach me, you can take a look at the accounts below.
        </p>
        <br />
        <br />
        <p className="title">
          Contact: <b>mdeniz.info@gmail.com</b>
        </p>

        <div style={{ marginTop: 30 }}>
          <Button link="https://twitter.com/muhammeddenz">
            <img src="icons/twitter.svg" alt="twitter" />
          </Button>

          <Button link="https://github.com/muhammeddeniz">
            <img src="icons/github.svg" alt="github" />
          </Button>

          <Button link="http://linkedin.com/in/muhammed-deniz-249554182">
            <img src="icons/linkedin.svg" alt="linkedin" />
          </Button>

          <Button link="https://medium.com/@muhammeddeniz024">
            <img src="icons/medium.svg" alt="medium" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Home;
